import Application from "../Application";
import { lerp, easeInOutSine } from "../utils";
import { rouler } from "./rouler";

/**
 * In an earlier version, the drawer and door animation was automatically tied
 * to the domain model so that it was not possible to change the open property
 * without seeing the animation. This function replaces the original behavior,
 * but with slightly different syntax.
 *
 * Old style:
 *
 *      drawer.open = 1.0;
 *
 * New style:
 *
 *      animateOpen(drawer, 1.0);
 *
 * NB: it works for anything with an 'open' property, which should include
 * murphy beds as well as doors and drawers.
 */
const animateOpen = (target: number, model: { open: number; }) => {
    const start = model.open;

    rouler(500, (a: number) => {
        model.open = lerp(start, target, easeInOutSine(a));
        Application.do('pipeline-update');
    });
};

export default animateOpen;
